import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';
import {Link} from "react-router-dom";

import Grid from '../../../components/cms/grid';
import AddNewButton from '../../../components/cms/grid/addNewButton';

const initCriteria = {
  id: '',
  sortBy: 'id',
  order: 'desc',
};

const Items = ({ t, getColumns, service }) => (
  <div>
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-money" /> {t('Tokens balance for company')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <Link to={service.getCompanyRoute()} className={"btn btn-success btn-brand"}>
                <i className="fa fa-arrow-circle-left mr-2"></i>
                Back to company
              </Link>

              <AddNewButton
                to={service.getCompanyRoute() + "/tokens-balance/create"}
                permissionToCreate={service.getCreatePermissions()}
              />
            </div>
            <Grid
              id="fonts"
              service={service}
              columns={getColumns(t)}
              initCriteria={initCriteria}
              saveFilter={false}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Items.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Items;



// WEBPACK FOOTER //
// ./src/views/companies/tokensBalance/Items.jsx